import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../api";

export default function MegaScholarshipParticipants() {
  const { id } = useParams(); // exam_id
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // =========================
  // LOAD PARTICIPANTS
  // =========================
  const loadParticipants = async () => {
    try {
      setLoading(true);
      setError("");

      const res = await api.get(
        `/admin/mega-scholarship/${id}/participants`
      );

      setRows(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Participants load error:", err);
      setError("Failed to load participants");
    } finally {
      setLoading(false);
    }
  };

  // =========================
  // EFFECT
  // =========================
  useEffect(() => {
    if (!id) {
      setError("Invalid exam id");
      setLoading(false);
      return;
    }
    loadParticipants();
    // eslint-disable-next-line
  }, [id]);

  // =========================
  // RELEASE AMOUNT
  // =========================
  const releaseAmount = async (p) => {
    const amount = prompt("Enter reward amount (₹)");
    if (!amount || isNaN(amount)) {
      alert("Invalid amount");
      return;
    }

    const upi = prompt("Enter UPI transaction ID");
    if (!upi) return;

    try {
      await api.post("/admin/mega-scholarship/release", {
        participant_id: p.id,
        amount: Number(amount),
        upi_txn: upi
      });

      alert("✅ Reward released successfully");
      loadParticipants();
    } catch (err) {
      console.error("Release error:", err);
      alert(err.response?.data?.error || "Release failed");
    }
  };

  // =========================
  // UI STATES
  // =========================
  if (loading) {
    return <p style={{ padding: 30 }}>Loading participants...</p>;
  }

  if (error) {
    return (
      <div style={{ padding: 30 }}>
        <h2>🏆 Mega Scholarship Participants</h2>
        <p style={{ color: "red" }}>{error}</p>
        <button onClick={() => navigate(-1)}>⬅ Back</button>
      </div>
    );
  }

  if (!rows.length) {
    return (
      <div style={{ padding: 30 }}>
        <h2>🏆 Mega Scholarship Participants</h2>
        <p>No participants found</p>
        <button onClick={() => navigate(-1)}>⬅ Back</button>
      </div>
    );
  }

  // =========================
  // MAIN TABLE
  // =========================
  return (
    <div style={{ padding: 30 }}>
      <h2>🏆 Mega Scholarship Participants</h2>

      <table
        width="100%"
        border="1"
        cellPadding="10"
        style={{ borderCollapse: "collapse" }}
      >
        <thead>
          <tr>
            <th>Rank</th>
            <th>Name</th>
            <th>Score</th>
            <th>Reward</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {rows.map((p) => (
            <tr key={p.id}>
              <td>{p.rank ?? "-"}</td>
              <td>{p.student_name}</td>
              <td>{p.score ?? 0}</td>
              <td>₹{p.reward_amount ?? 0}</td>
              <td>
                {p.amount_released ? "✅ Released" : "⏳ Pending"}
              </td>
              <td>
                {!p.amount_released && (
                  <button onClick={() => releaseAmount(p)}>
                    💸 Release
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <br />
      <button onClick={() => navigate(-1)}>⬅ Back</button>
    </div>
  );
}
